<template>
  <div class="button-tiles-container">
    <h1 v-if="!simpleTiles">
      Don't leave your family's future to chance,
      <span>create your will today</span>
    </h1>
    <h2 v-if="!simpleTiles">
      <span>Sign up</span> and let us guide you through the process, ensuring
      that your final wishes are clear, and your family is well protected.
    </h2>
    <h1 v-if="simpleTiles"><span>How does it work?</span></h1>
    <div class="child">
      <ButtonTiles :tiles="tiles" :simpleTiles="simpleTiles" />
    </div>
    <div v-if="simpleTiles" class="mt-10">
      <GradientButton
        v-if="whitelabel.brand !== 'teba'"
        :title="buttonText"
        :callout="'right'"
        @gradientButtonClicked="handleButtonClick"
      />
    </div>
  </div>
</template>

<script>
  import ButtonTiles from './ButtonTiles.vue';

  export default {
    name: 'ButtonTilesContainer',
    components: {
      ButtonTiles,
    },
    props: {
      tiles: {
        required: true,
        default: [],
        type: Array,
      },
      simpleTiles: {
        default: false,
        type: Boolean,
      },
      buttonText: {
        default: 'START YOUR FREE WILL',
        type: String,
      },
    },
    methods: {
      handleButtonClick() {
        this.$router.push('/register');
      },
    },
  };
</script>

<style scoped lang="scss">
  .button-tiles-container {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    h1 {
      max-width: 928px;
      font-family: Montserrat;
      font-size: 28px;
      font-weight: 300;
      line-height: 34px;
      letter-spacing: -0.0025em;
      text-align: center;
      span {
        font-family: Montserrat;
        font-size: 28px;
        font-weight: 500;
        line-height: 34px;
        letter-spacing: -0.0025em;
        text-align: center;
      }
    }
    h2 {
      max-width: 928px;
      margin-top: 22px;
      font-family: Montserrat;
      font-size: 22px;
      font-weight: 400;
      line-height: 26px;
      text-align: center;
    }
    span {
      font-family: Montserrat;
      font-size: 22px;
      font-weight: 600;
      line-height: 26px;
      text-align: center;
    }

    .child {
      margin-top: 56px;
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .button-tiles-container {
      h2 {
        font-size: 18px;
      }
      span {
        font-size: 18px;
      }
    }
  }
</style>
